import type { IconSvgObject } from './types';

const BaselineIcon: IconSvgObject = [
  ["path", { d: "M18 16L12.7083 4.45453C12.5814 4.17757 12.3047 4 12 4C11.6953 4 11.4186 4.17757 11.2917 4.45453L6 16M8 12H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 20H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BaselineIcon;
